// extracted by mini-css-extract-plugin
module.exports = {"InboxPopover":"Nav_InboxPopover__2Pg1_"};